import { SlatePlugin } from '../../../../slatePlugins/slatePlugins.types';
import { MediaProps, MediaType } from '../media-constant';
import { renderFrameUpload } from './renderElement';

export const FramePlugin = (props?: MediaProps): SlatePlugin => {
  return {
    renderElement: renderFrameUpload(props),
    voidTypes: [MediaType.FRAME],
  };
};
